@if(isPageInitialized) {
  <ng-container *transloco="let t; prefix: 'assetOverview.details'">
  <div class="dashboard-top-section d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-2">
      <button class="back-button" [title]="t('back')" (click)="onBackButtonClick()">
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z" fill="#9FA1A4"/>
          </svg>
        </span>
      </button>
      <h1> {{ assetName }} </h1>
    </div>

    <div class="header-actions d-flex">
      <button class="schedule-maintenance-button" (click)="onScheduleMaintenanceClick()">
        <span class="schedule-maintenance-button-text">{{ t('scheduleMaintenance') }}</span>
      </button>
    </div>
  </div>

  <div class="dashboard-widgets">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-products-installed-widget [assetId]="assetId"></app-products-installed-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-fuel-consumption-widget [assetId]="assetId"></app-fuel-consumption-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-inspections-and-compliance-widget [assetId]="assetId"></app-inspections-and-compliance-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-total-downtime-widget [assetId]="assetId"></app-total-downtime-widget>
      </div>
    </div>
  </div>

  <div class="bottom-grid-section">
    <div class="bottom-grid-sec-left">
      <div class="tabs">
        <!-- Tabs header -->
        <div class="tabs__header">
          <button
            class="tabs__tab-button"
            [class.tabs__tab-button--active]="activeTab === 'asset-information'"
            (click)="activeTab = 'asset-information'">
            {{ t('tabs.assetInformation') }}
          </button>

          <button
            class="tabs__tab-button"
            [class.tabs__tab-button--active]="activeTab === 'maintenance'"
            (click)="activeTab = 'maintenance'">
            {{ t('tabs.maintenance') }}
          </button>

          <button
            class="tabs__tab-button"
            [class.tabs__tab-button--active]="activeTab === 'compliance'"
            (click)="activeTab = 'compliance'">
            {{ t('tabs.compliance') }}
          </button>
        </div>

        <!-- Tabs content -->
        <div class="tabs__content">
          <ng-container [ngSwitch]="activeTab">         
            <div *ngSwitchCase="'asset-information'">
              <app-asset-information
                [assetId]="assetId"
                [assetName]="assetName"
                (assetNameChange)="onAssetRenamed($event)">
              </app-asset-information>
            </div>

            <div *ngSwitchCase="'maintenance'">
              <app-maintenance
                [assetId]="assetId">
              </app-maintenance>
            </div>

            <div *ngSwitchCase="'compliance'">
              <app-compliance
                [assetId]="assetId">
              </app-compliance>
            </div>  
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  </ng-container>
}